import * as React from 'react';
import { Typography } from '@material-ui/core';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';

interface Props {
  searchText: string
}
type LocalStyles = 'root';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing.unit * 4,
  },
});


type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class NoSearchResult extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    return (
      <Paper elevation={1} className={this.props.classes.root}>
        <Typography variant="h4">
          {translation.t('noSearchResult.title', { searchText: this.props.searchText})}
        </Typography>
      </Paper>
    );
  }
}

export default withStyles(localStyles)(NoSearchResult);
